(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[68],{

/***/ "IaLl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./components/atoms/Picture/index.js + 3 modules
var Picture = __webpack_require__("Z1QS");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./styles/theme.js
var theme = __webpack_require__("NVT0");

// CONCATENATED MODULE: ./utils/calculator.js
var xIsPercentOfY = function xIsPercentOfY(x, y) {
  return x / (y / 100);
};
// CONCATENATED MODULE: ./components/atoms/ProportionalImg/utils/getProportionalImgCss.js



/**
 * Calculate width and height of Cover image based on given width
 * By ultilizing the ratio of an image taken from the design, this util
 * can prevent an image content being cut off on changing viewport.
 * The idea is to use vh and vw, as they are always relative to a viewport size.
 *
 * Use case. On the design, an image is given for tablet in the size 768 * 500
 * If we set width = 100% viewport and height = 500px, as the browser resized, image
 * will be cut off and lost its content. However, if we calculate the ratio from the number
 * const ratio = imgWidth / imgHeight; and then calculate the height of image
 * base on width in vw unit, we will have image height in vw unit, and it will resize without
 * losing image content.
 *
 *
 * @param  {object} dimension array of dimension for each breakpoint
 * @param  {bool} isCover does image cover the entire screen (e.g: Hero image)
 * @param  {string} breakpoint 'mobile' | 'tablet' | 'desktop' | 'desktopLarge'
 */

var getProportionalImgCss_getProportionalImgCss = function getProportionalImgCss(dimension, isCover, breakpoint) {
  // Set up variables
  var screenWidth = theme["a" /* default */].screenWidths[breakpoint];
  var _dimension$breakpoint = dimension[breakpoint],
      imgWidth = _dimension$breakpoint.imgWidth,
      imgHeight = _dimension$breakpoint.imgHeight,
      wrapperWidth = _dimension$breakpoint.wrapperWidth; // Make sure that parent padding is not added to total width

  var pl = dimension[breakpoint].wrapperPadLeft || 0;
  var pr = dimension[breakpoint].wrapperPadRight || 0;
  var newWrapperWidth = wrapperWidth - pl - pr; // Calculate max view width from given wrapperWidth
  // Because if wrapper < 100vw, the size of image can only equal to the size of wrapperWidth

  var maxVw = xIsPercentOfY(newWrapperWidth, screenWidth); // Calculate

  var ratio = imgWidth / imgHeight;
  var widthInVw = xIsPercentOfY(imgWidth, newWrapperWidth) <= maxVw ? xIsPercentOfY(imgWidth, newWrapperWidth) : maxVw; // const widthInVw = xIsPercentOfY(imgWidth, newWrapperWidth);

  var heightInVw = widthInVw / ratio;
  var zIndex = dimension[breakpoint].zIndex || 1; // Return CSS

  return Object(styled_components_browser_esm["css"])(["max-height:", ";width:", "px;height:", "px;z-index:", ";", " ", " img{object-fit:", ";object-position:", ";}"], dimension[breakpoint].imgMaxHeight || '100%', imgWidth, imgHeight, zIndex, (isCover || breakpoint === 'mobile') && Object(styled_components_browser_esm["css"])(["width:", "vw;height:", "vw;"], widthInVw, heightInVw), !isCover && Object(styled_components_browser_esm["css"])(["height:auto;"]), dimension[breakpoint].imgFit || 'cover', dimension[breakpoint].imgAlign || 'center');
};
// CONCATENATED MODULE: ./components/atoms/ProportionalImg/CoverImage.jsx


 // Style for Cover Image

var CoverImage = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CoverImage",
  componentId: "sc-9acjsa-0"
})(["", ";img{max-width:100%;max-height:100%;}@media ", "{", ";}@media ", "{", ";}@media ", "{", ";}"], function (_ref) {
  var dimension = _ref.dimension,
      isCover = _ref.isCover;
  return getProportionalImgCss_getProportionalImgCss(dimension, isCover, 'mobile');
}, theme["a" /* default */].breakpoints.tablet, function (_ref2) {
  var dimension = _ref2.dimension,
      isCover = _ref2.isCover;
  return getProportionalImgCss_getProportionalImgCss(dimension, isCover, 'tablet');
}, theme["a" /* default */].breakpoints.desktop, function (_ref3) {
  var dimension = _ref3.dimension,
      isCover = _ref3.isCover;
  return getProportionalImgCss_getProportionalImgCss(dimension, isCover, 'desktop');
}, theme["a" /* default */].breakpoints.desktopLarge, function (_ref4) {
  var dimension = _ref4.dimension,
      isCover = _ref4.isCover;
  return getProportionalImgCss_getProportionalImgCss(dimension, isCover, 'desktopLarge');
});
/* harmony default export */ var ProportionalImg_CoverImage = (CoverImage);
// CONCATENATED MODULE: ./components/atoms/ProportionalImg/utils/getContainedImgCss.js

/**
 * Generate Wrapper of ContainedImage CSS from breakpoint
 * This help images that are not full screen keeps its ratio on changing viewport
 *
 * @param  {object} dimension array of dimension for each breakpoint
 * @param  {string} breakpoint 'mobile' | 'tablet' | 'desktop' | 'desktopLarge'
 */

var getContainedImgCss_getContainedImgCss = function getContainedImgCss(dimension, breakpoint) {
  var _dimension$breakpoint = dimension[breakpoint],
      imgWidth = _dimension$breakpoint.imgWidth,
      imgHeight = _dimension$breakpoint.imgHeight;
  var ratio = imgWidth / imgHeight;
  return Object(styled_components_browser_esm["css"])(["padding-top:", "%;"], 100 / ratio);
};
// CONCATENATED MODULE: ./components/atoms/ProportionalImg/ContainedImage.jsx
var __jsx = react_default.a.createElement;




 // Assenble Contained image component

var ContainedImage_ContainedImage = function ContainedImage(_ref) {
  var dimension = _ref.dimension,
      isCover = _ref.isCover,
      children = _ref.children;
  return /*#__PURE__*/react_default.a.createElement(ImageBox, {
    dimension: dimension,
    isCover: isCover
  }, /*#__PURE__*/react_default.a.createElement(ImageWrapper, {
    dimension: dimension
  }, children));
}; // Style image


var ImageBox = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ContainedImage__ImageBox",
  componentId: "kmkz0a-0"
})(["", ";img{max-width:100%;max-height:100%;}@media ", "{", ";}@media ", "{", ";}@media ", "{", ";}"], function (_ref2) {
  var dimension = _ref2.dimension,
      cover = _ref2.cover;
  return getProportionalImgCss_getProportionalImgCss(dimension, cover, 'mobile');
}, theme["a" /* default */].breakpoints.tablet, function (_ref3) {
  var dimension = _ref3.dimension,
      cover = _ref3.cover;
  return getProportionalImgCss_getProportionalImgCss(dimension, cover, 'tablet');
}, theme["a" /* default */].breakpoints.desktop, function (_ref4) {
  var dimension = _ref4.dimension,
      cover = _ref4.cover;
  return getProportionalImgCss_getProportionalImgCss(dimension, cover, 'desktop');
}, theme["a" /* default */].breakpoints.desktopLarge, function (_ref5) {
  var dimension = _ref5.dimension,
      cover = _ref5.cover;
  return getProportionalImgCss_getProportionalImgCss(dimension, cover, 'desktopLarge');
}); // Image wrapper gets the height of children, but keeps its ratio and hide overflow

var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ContainedImage__ImageWrapper",
  componentId: "kmkz0a-1"
})(["", ";position:relative;> div{position:absolute;top:0;left:0;bottom:0;right:0;}@media ", "{", ";}@media ", "{", ";}@media ", "{", ";}"], function (_ref6) {
  var dimension = _ref6.dimension;
  return getContainedImgCss_getContainedImgCss(dimension, 'mobile');
}, theme["a" /* default */].breakpoints.tablet, function (_ref7) {
  var dimension = _ref7.dimension;
  return getContainedImgCss_getContainedImgCss(dimension, 'tablet');
}, theme["a" /* default */].breakpoints.desktop, function (_ref8) {
  var dimension = _ref8.dimension;
  return getContainedImgCss_getContainedImgCss(dimension, 'desktop');
}, theme["a" /* default */].breakpoints.desktopLarge, function (_ref9) {
  var dimension = _ref9.dimension;
  return getContainedImgCss_getContainedImgCss(dimension, 'desktopLarge');
});
ContainedImage_ContainedImage.defaultProps = {
  isCover: false
};
/* harmony default export */ var ProportionalImg_ContainedImage = (ContainedImage_ContainedImage);
// CONCATENATED MODULE: ./components/atoms/ProportionalImg/index.jsx
var ProportionalImg_jsx = react_default.a.createElement;





var ProportionalImg_ProportionalImg = function ProportionalImg(_ref) {
  var dimension = _ref.dimension,
      isCover = _ref.isCover,
      images = _ref.images,
      placeholder = _ref.placeholder,
      alt = _ref.alt,
      className = _ref.className;
  return isCover ?
  /*#__PURE__*/
  // If specified as cover video
  react_default.a.createElement(ProportionalImg_CoverImage, {
    dimension: dimension,
    className: className,
    isCover: isCover
  }, /*#__PURE__*/react_default.a.createElement(Picture["a" /* default */], {
    images: images,
    placeholder: placeholder,
    alt: alt,
    fullWidth: true
  })) :
  /*#__PURE__*/
  // If specified as contained video
  react_default.a.createElement(ProportionalImg_ContainedImage, {
    dimension: dimension,
    className: className,
    isCover: isCover
  }, /*#__PURE__*/react_default.a.createElement(Picture["a" /* default */], {
    images: images,
    placeholder: placeholder,
    alt: alt
  }));
}; // Default Props for this component to ensure there are default value for props.


ProportionalImg_ProportionalImg.defaultProps = {
  isCover: false,
  images: [],
  placeholder: null,
  className: null
};
/* harmony default export */ var atoms_ProportionalImg = __webpack_exports__["a"] = (ProportionalImg_ProportionalImg);

/***/ }),

/***/ "USIO":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/home-highlight-desktop-75c904e9a55b2cce3d68f1796d5c8e92.jpg", "placeholder": ""};

/***/ }),

/***/ "nyTJ":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/home-highlight-mobile-61a54a29fc59125e47aaaf5c5078482f.jpg", "placeholder": ""};

/***/ }),

/***/ "ofUY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NVT0");
/* harmony import */ var components_atoms_ProportionalImg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("IaLl");
/* harmony import */ var _images_home_highlight_mobile_jpg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("nyTJ");
/* harmony import */ var _images_home_highlight_mobile_jpg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_images_home_highlight_mobile_jpg__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _images_home_highlight_tablet_jpg_placeholder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("vOWJ");
/* harmony import */ var _images_home_highlight_tablet_jpg_placeholder__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_images_home_highlight_tablet_jpg_placeholder__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _images_home_highlight_desktop_jpg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("USIO");
/* harmony import */ var _images_home_highlight_desktop_jpg__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_images_home_highlight_desktop_jpg__WEBPACK_IMPORTED_MODULE_5__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;






var dimension = {
  mobile: {
    imgWidth: 325,
    imgHeight: 325,
    wrapperWidth: styles_theme__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].screenWidths.mobile,
    zIndex: -1
  },
  tablet: {
    imgWidth: 768,
    imgHeight: 325,
    wrapperWidth: styles_theme__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].screenWidths.tablet,
    zIndex: -1
  },
  desktop: {
    imgWidth: 1024,
    imgHeight: 520,
    wrapperWidth: styles_theme__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].screenWidths.desktop,
    zIndex: -1
  },
  desktopLarge: {
    imgWidth: 1920,
    imgHeight: 650,
    wrapperWidth: styles_theme__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].screenWidths.desktopLarge
  }
};
var images = [{
  src: _images_home_highlight_desktop_jpg__WEBPACK_IMPORTED_MODULE_5___default.a.url,
  width: dimension.desktopLarge.width,
  height: dimension.desktopLarge.height,
  media: styles_theme__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].breakpoints.desktopLarge,
  key: '1'
}, {
  src: _images_home_highlight_tablet_jpg_placeholder__WEBPACK_IMPORTED_MODULE_4___default.a.url,
  width: dimension.tablet.width,
  height: dimension.tablet.height,
  media: styles_theme__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].breakpoints.tablet,
  key: '2'
}, {
  src: _images_home_highlight_mobile_jpg__WEBPACK_IMPORTED_MODULE_3___default.a.url,
  width: dimension.mobile.width,
  height: dimension.mobile.height,
  key: '3'
}];

var ImgHighlight = function ImgHighlight() {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(components_atoms_ProportionalImg__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], {
    dimension: dimension,
    images: images,
    placeholder: _images_home_highlight_tablet_jpg_placeholder__WEBPACK_IMPORTED_MODULE_4___default.a.placeholder,
    alt: "SOUNDBOKS HIGHLIGHT Image",
    isCover: true
  });
};

/* harmony default export */ __webpack_exports__["default"] = (ImgHighlight);

/***/ }),

/***/ "vOWJ":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/home-highlight-tablet-9b0dc21bb424dd69bf9936190b57a0b9.jpg", "placeholder": "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAKABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAcDBAUG/8QAJBAAAgEEAgEEAwAAAAAAAAAAAQIDAAQFERIhBgcUIkEVMaH/xAAWAQEBAQAAAAAAAAAAAAAAAAAFBAb/xAAdEQEAAgEFAQAAAAAAAAAAAAABAhEAAwQTIXES/9oADAMBAAIRAxEAPwCxaekGLu0jkuYshLwCLoyGEaP7PQHLQ7/lcj514nHh8paWmFxctvYJPylyLzF2iBbQHDkd6IBJA+6ceRlkSCV0kdX4E8gdHdLvPXdz7izPuJttIob5nsHe91nNp9E2UpL6te1iOslUAZh31jmYrmSP80pVCQrLC2mBO999/dFSRsWTkxJYs+yT2fkaKT5pHWQcUXus/9k="};

/***/ })

}]);